/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { FileDownloadOutlined } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { ButtonGroup } from "@mui/material";

import { StyledMenu } from "./stylesMenu";
import { LeftButton, RightButton } from "./stylesButton";
import serviceRebalanceUsina from "@/services/serviceRebalanceUsina";

const fieldList = [
    "SELECIONAR TODOS",
    "ID_REBALANCE_USINA_INSTALACAO",
    "EXCLUIR",
    "VERSAO",
    "UC",
    "NOME",
    "COD_FPARCEIRO",
    "CLASSE",
    "DISP",
    "PLANTA",
    "MES_REF",
    "INJECAO_PREVISTA",
    "INJECAO_REALIZADA",
    "SALDO_CONSOLIDADO_ANTERIOR",
    "SALDO_CONSOLIDADO_ATUAL",
    "SALDO_ALSOL_ANTERIOR",
    "SALDO_ALSOL_ATUAL",
    "SALDO_CONCESSIONARIA_ANTERIOR",
    "SALDO_CONCESSIONARIA_ATUAL",
    "SALDO_OUTROS_ANTERIOR",
    "SALDO_OUTROS",
    "PARCEIRO",
    "COTA_CTR",
    "PER_MIN_COTA",
    "PER_MAX_COTA",
    "AJUSTE_MANUAL",
    "INJECAO_FIXA",
    "TIPO_INJECAO_FIXA_CALCULADA",
    "STATUS_FATURA_PREVISTA",
    "MEDIA_CONSUMO",
    "COTA_KWH",
    "PER_SALDO_SOBRE_COTA",
    "PER_MEDIA_CONSUMO_SOBRECOTA",
    "PREV_CONS_M1",
    "PREV_CONS_M2",
    "SALDO_REBALANCE_ATUAL",
    "COTA_KWH_CALCULADA",
    "COTA_50_DISP",
    "PREVISAO_CONSUMO",
    "PREV_CONSUMO_DISP",
    "SALDO_50_COTA",
    "SALDO_50_CONSUMO",
    "REDUCAO",
    "ACRESCIMO",
    "INJECAO",
    "INJECAO_TRAVA",
    "TRAVA",
    "AJUSTE",
    "NOVA_COTA",
    "PER_DISTRIB_AJUSTADA",
    "DIF_PREVISAO_SALDO",
    "DIF_SALDO",
    "DIF_PERC",
    "DIFERENCA_COTA",
    "PER_SALDO_ATUAL",
    "PER_DIFERENCA_COTA",
    "PER_DIFERENCA_COTA_E_SALDO",
];

interface IButtonDownloadProps {
    onClick: any;
    disabled: boolean;
}

export default function ButtonDownload({ onClick, disabled }: IButtonDownloadProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [checked, setChecked] = React.useState<string[]>([]);
    const [layoutData, setLayoutData] = React.useState<[]>([]);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleToggle = (value: string) => () => {
        if (value === "SELECIONAR TODOS") {
            setChecked(checked.length === fieldList.length - 1 ? [] : fieldList.slice(1));
            return;
        }

        const newChecked = checked.includes(value) ? checked.filter((item) => item !== value) : [...checked, value];

        setChecked(newChecked);
    };

    const handleDownload = () => {
        onClick();
        if (JSON.stringify(layoutData.sort()) !== JSON.stringify(checked.sort())) {
            serviceRebalanceUsina.setLayoutDownload({
                usuarioId: 0,
                listaCampos:
                    checked.length === fieldList.slice(1).length
                        ? JSON.stringify(fieldList.slice(1))
                        : JSON.stringify(checked),
            });
        }
    };

    const loadLayoutDownload = () => {
        serviceRebalanceUsina
            .getLayoutDownload()
            .then((response) => {
                setChecked(JSON.parse(response.data.listaCampos));
                setLayoutData(JSON.parse(response.data.listaCampos));
            })
            .catch(() => setChecked([]));

        if (checked.find((value) => value === "SELECIONAR TODOS")) {
            setChecked(checked.length === fieldList.length - 1 ? [] : fieldList.slice(1));
            return;
        }
    };

    React.useEffect(() => {
        loadLayoutDownload();
    }, []);

    return (
        <div>
            <ButtonGroup fullWidth sx={{ mt: 2, boxShadow: "none" }} variant="contained" aria-label="Button group menu">
                <LeftButton
                    id="leftDownloadButton"
                    onClick={handleDownload}
                    disabled={disabled}
                    startIcon={<FileDownloadOutlined />}
                >
                    Download
                </LeftButton>
                <RightButton
                    id="rightDownloadButton"
                    aria-controls={open ? "customized-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    disableElevation
                    onClick={handleClick}
                    disabled={disabled}
                    sx={{
                        width: "10%",
                    }}
                >
                    <KeyboardArrowDownIcon />
                </RightButton>
            </ButtonGroup>
            <StyledMenu
                MenuListProps={{
                    "aria-labelledby": "customized-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <List
                    sx={{
                        maxWidth: 460,
                        maxHeight: 200,
                        overflow: "auto",
                        bgcolor: "background.paper",
                    }}
                >
                    {fieldList.map((value) => {
                        const labelId = `checkbox-${value}`;

                        return (
                            <ListItem key={value} disablePadding>
                                <ListItemButton role={undefined} onClick={handleToggle(value)} dense>
                                    <ListItemIcon>
                                        <Checkbox
                                            id="checkbox"
                                            edge="start"
                                            checked={
                                                value === "SELECIONAR TODOS"
                                                    ? checked.length === fieldList.length - 1
                                                    : checked.indexOf(value) !== -1
                                            }
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ "aria-labelledby": labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        id={labelId}
                                        primary={value === "SELECIONAR TODOS" ? <strong>{value}</strong> : `${value}`}
                                    />
                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>
            </StyledMenu>
        </div>
    );
}
